<template>
  <div :class="`commentView__item ${hasLine?'commentView__item--line':''}`">
    <div v-if="type === 'comment'" class="commmentView__item__avatar" :style="{ backgroundImage:`url(${getImg(item.owner.avatar)})` }" @click="jumpToProfile(item.owner.user_id)">
      <!-- <img :src="`${item.owner.avatar}`" /> -->
    </div>
    <div class="commentView__item__commentWrapper">
      <div :class="`commentView__item__commentWrapper__content ${showBtn && btnStatus === 'expand' ? 'all':''}`" ref="content_all">
        <span class="commentView__item__commentWrapper__name" @click="jumpToProfile(item.owner.user_id)">
          <span class="name">{{getShortName(item.owner.name)}}</span>
          <span class="commentView__item__commentWrapper__segment" v-if="item.owner.segment&&item.owner.segment.name">[{{item.owner.segment&&item.owner.segment.name}}]</span>
        </span>
        :
        <span v-if="type === 'reply'" class>
          回复
          <span class="commentView__item__commentWrapper__name" @click="jumpToProfile(item.reply_user.user_id)">@{{item.reply_user?getShortName(item.reply_user.name):''}}</span>
          :
        </span>
        <span class="commentView__content" v-html="escape(item.content)"></span>
      </div>
      <p v-if="showBtn" class="showAllBtn" @click.stop="expandClickEvent()">{{btnStatus === 'expand' ? "展开":"收起"}}</p>
      <template v-if="type === 'comment' && item.photos">
        <span style="color: #eb7350;cursor: pointer;font-size:14px;display: block;">评论配图</span>
        <img :src="getImg(item.photos)" style="width:40px;height:40px;cursor: pointer;" @click="bigImage(item.photos)" />
      </template>
      <div class="commentView__item__commentWrapper__func">
        <span class="commentView__item__commentWrapper__time">{{dealWithTime(item.create_time)}}</span>
        <div class="commentView__item__commentWrapper__handles">
          <div v-if="!item.is_self" class="commentView__item__commentWrapper__handle follow" @click="followEvent(item.is_follow)">
            <span class="commentView__item__commentWrapper__handle__text">{{item.is_follow?"取消关注":"关注"}}</span>
            <span class="commentView__item__commentWrapper__line"></span>
          </div>
          <template v-if="item.is_self || ownerInfo.is_staff || item.is_post_owner">
            <div class="commentView__item__commentWrapper__handle" @click="deleteEvent()">
              <span class="commentView__item__commentWrapper__handle__text">删除</span>
            </div>
            <span class="commentView__item__commentWrapper__line"></span>
          </template>
          <div class="commentView__item__commentWrapper__handle" @click="openInputEvent()">
            <span class="commentView__item__commentWrapper__handle__text">回复</span>
          </div>
          <span class="commentView__item__commentWrapper__line"></span>
          <div class="commentView__item__commentWrapper__handle" @click="likeEvent(item.is_like)">
            <img class="commentView__item__commentWrapper__handle__icon" :src="item.is_like?images.zan_select:images.zan_unselect" />
            <span class="commentView__item__commentWrapper__handle__text">{{item.like_count === 0?"赞":item.like_count}}</span>
          </div>
          <div v-if="!item.is_self" class="commentView__item__commentWrapper__handle" @click="sendFlower()">
            <span class="commentView__item__commentWrapper__line"></span>
            <img class="commentView__item__commentWrapper__handle__icon" :src="item.is_flower?images.flower_select:images.flower_unselect" />
            <span class="commentView__item__commentWrapper__handle__text sendflower">{{item.flower_count === 0?"送花":item.flower_count}}</span>
          </div>
        </div>
      </div>
      <div class="commentView__item__commentWrapper__inputView" v-if="openInput">
        <InputView type="reply" :placeholder="`回复@${item.owner.name}:`" />
      </div>
    </div>
    <!-- 全屏图片浏览视图 -->
    <PreviewPhotos ref="shadowPhotos" />
  </div>
</template>
<script>
import InputView from "./InputView.vue";
import PreviewPhotos from './PreviewPhotos.vue';

import {
  IMG_EMOIJ,
  IMG_PHOTO_BLUE,
  IMG_VIDEO,
  IMG_ZAN_UNSELECT,
  IMG_ZAN_SELECT,
  IMG_FLOWER_UNSELECT,
  IMG_FLOWER_SELECT
} from "../../assets";
import { Utils } from '../../utils'

export default {
  name: "ReplyItem",
  components: {
    InputView,
    PreviewPhotos
  },
  props: {
    type: {
      type: String,
      default: "comment"
    },
    item: {
      type: Object,
      required: true
    },
    hasLine: {
      type: Boolean,
      default: true
    },
    ownerInfo: {
      type: Object
    }
  },
  data () {
    return {
      openInput: false,
      images: {
        emoij: IMG_EMOIJ,
        photo: IMG_PHOTO_BLUE,
        video: IMG_VIDEO,
        zan_unselect: IMG_ZAN_UNSELECT,
        zan_select: IMG_ZAN_SELECT,
        flower_unselect: IMG_FLOWER_UNSELECT,
        flower_select: IMG_FLOWER_SELECT
      },
      // 文字折叠
      showBtn: false,
      btnStatus: 'expand', //expand, collapse   
    };
  },
  computed: {},

  methods: {
    ...Utils,
    // 图片放大查看
    bigImage (url) {
      this.$refs.shadowPhotos.showShadowView([url])
    },
    getShortName (name) {
      return name.slice(0, 10);
    },
    openInputEvent () {
      this.openInput = !this.openInput;
    },
    //点赞评论或回复
    likeEvent (is_like) {
      let data = { pk: this.item.pk, is_like: is_like };
      if (this.$parent.likeReplyEvent) {
        this.$parent.likeReplyEvent(this.type, data);
      }
    },
    //删除评论或回复
    deleteEvent () {
      let data = { pk: this.item.pk };
      if (this.$parent.deleteReplyEvent) {
        this.$parent.deleteReplyEvent(this.type, data);
      }
    },
    //送花评论或回复
    sendFlower () {
      let data = { pk: this.item.pk };
      if (this.item.is_flower === false && this.$parent.flowerReplyEvent) {
        this.$parent.flowerReplyEvent(this.type, data);
      }
    },
    // 关注/取关事件
    followEvent (is_follow) {
      let data = { "followers": [this.item.owner.user], "is_follow": is_follow }
      if (this.$parent.followReplyEvent) {
        this.$parent.followReplyEvent(this.type, data)
      }
    },
    //跳到个人主页
    jumpToProfile (owner) {
      this.$router.push(`/profile/${owner}`);
    },
    //展开、收起事件
    expandClickEvent () {
      if (this.btnStatus === 'expand') {
        this.btnStatus = 'collapse'
      } else if (this.btnStatus === 'collapse') {
        this.btnStatus = 'expand'
      }
    },

    //--------inputView 组件的回调函数
    //对评论回复 或者 对回复的回复
    publish (type, data) {
      data["comment"] =
        this.type === "comment" ? this.item.pk : this.item.comment;
      data["reply_user"] = this.item.owner.user;
      console.log(this.item);
      this.openInputEvent();
      if (this.$parent.publishReply) {
        this.$parent.publishReply(type, data);
      }
    }
  },
  create () { },
  mounted () {
    // console.log(this.hasAvatar);
    let initContentHeight = 94;
    if (this.$refs.content_all.clientHeight > initContentHeight) {
      this.showBtn = true;
    }
  }
};
</script>

<style scoped lang="less">
.commentView__item {
  padding: 10px 0px;
  width: calc(100%);

  display: flex;
  flex-direction: row;
}
.commentView__item--line {
  border-bottom: solid 1px #d9d9d9;
}
.commmentView__item__avatar {
  margin-top: 6px;
  width: 30px;
  height: 30px;
  overflow: hidden;
  margin-right: 10px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  cursor: pointer;
}
.commmentView__item__avatar img {
  width: 100%;
  height: 100%;
}
.commentView__item__commentWrapper {
  flex: 1;
}
.commentView__item__commentWrapper__content {
  padding: 0 0 2px;
  line-height: 23px;
  word-wrap: break-word;
  color: #333333;
  font-size: 12px;
  &.all {
    max-height: 94px;
    overflow: hidden;
  }
}
.showAllBtn {
  color: #6b45e1;
  cursor: pointer;
  padding: 1px 0 3px;

  font-size: 14px;
}
.commentView__item__commentWrapper__name {
  color: #eb7350;
  cursor: pointer;
  .name {
    // max-width: 50%;
    // display: inline-flex;
    // line-height: 23px;
    // height: 23px;
    // overflow: hidden;
  }
}
.commentView__item__commentWrapper__segment {
  /* color: #5F0AFF; */
  /* font-size: 12px; */
  color: #666666;
  font-size: 11px;
  margin-left: 3px;
  font-weight: normal;
}
.commentView__item__commentWrapper__func {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.commentView__item__commentWrapper__time {
  color: #808080;
  font-size: 12px;
}
.commentView__item__commentWrapper__handles {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.commentView__item__commentWrapper__handle {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  .sendflower {
    width: -webkit-fill-available;
  }
}
.commentView__item__commentWrapper__line {
  border-right: solid 1px #d9d9d9;
  width: 1px;
  height: 10px;
  margin: 0 10px;
}
.commentView__item__commentWrapper__handle__icon {
  /* width: 20px; */
  height: 15px;
  margin-right: 5px;
  /* background-color: red; */
}
.commentView__item__commentWrapper__handle__text {
  font-size: 12px;
  color: #333333;
}
.commentView__item__commentWrapper__inputView {
  margin: 5px 0px;
  background: white;
  padding: 10px 16px;
}
.commentView__content {
  word-wrap: break-word;
  word-break: break-word;
}
.commentView__item {
  .commentView__item__commentWrapper__handle.follow {
    display: none;
  }
}
.commentView__item:hover {
  .commentView__item__commentWrapper__handle.follow {
    display: flex;
  }
}
</style>